import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import VisitorNavbar from "../component/VisitorNavbar";
import Footer from "../component/Footer";
import axios from "axios";
import { baseurl } from "../Baseurl";

const PaymentFailure = () => {
  const location = useLocation();
  const [message, setMessage] = useState("Processing...");
  const [txnid, setTxnid] = useState("");

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const txn = queryParams.get("txnid");

    if (txn) {
      setTxnid(txn);
      console.log("txn", txn);

      axios
        .post(`${baseurl}markPaymentAsFailed`, { txnid: txn })
        .then((res) => {
          console.log("Response from backend:", res.data);
          setMessage("Unfortunately, your payment has failed.");
        })
        .catch((err) => {
          console.error("Payment failure update error:", err.response?.data || err.message);
          setMessage("There was an issue processing the payment failure status.");
        });
    } else {
      setMessage("Invalid or missing transaction ID.");
    }
  }, [location.search]);

  return (
    <>
      <VisitorNavbar />
      <div className="container py-5">
        <h4 className="hesd mb-4 text-start">Payment Gateway</h4>
        <div className="row">
          <div className="col-md-6 offset-md-3 text-center">
            <div className="failure-icon mb-3">
              <span>&#10006;</span>
            </div>
            <h5 className="text-danger">{message}</h5>
            {txnid && (
              <p className="mt-2">
                <strong>Transaction ID:</strong> {txnid}
              </p>
            )}
            <a href="/" className="btn btn-outline-primary mt-3">
              Return to Home
            </a>
          </div>
        </div>
      </div>
      <Footer />
      <style>{`
        .failure-icon {
          width: 100px;
          height: 100px;
          border-radius: 50%;
          background-color: #f8d7da;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto;
          font-size: 48px;
          color: #dc3545;
          box-shadow: 0 0 10px rgba(220, 53, 69, 0.3);
        }
      `}</style>
    </>
  );
};

export default PaymentFailure;
